const initialState = {
  status: "invalid",
  data: null,
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "USER_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "USER_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
      };
    case "USER_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
